export const formatMessageTime = (timestamp: Date) => {
  const now = new Date();
  const messageDate = new Date(timestamp.getTime() + 8 * 60 * 60 * 1000);

  if (now.toDateString() === messageDate.toDateString()) {
    return messageDate.toLocaleTimeString("zh-TW", {
      hour: "2-digit",
      minute: "2-digit",
    });
  }
  return `${messageDate.toLocaleDateString()} ${messageDate.toLocaleTimeString("zh-TW", { hour: "2-digit", minute: "2-digit" })}`;
};
